import React from 'react';
import { t } from 'i18next';
import './screen.less';
import { TripStatusReportDto } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { Button, Carousel, Divider, Radio } from 'antd';
import TripPageItem from './TripPageItem';
import PageWithPermissions from '@/components/PageWithPermissions';
import { APP_PERMISSIONS } from '@/services/roleService';

const ORIGIN_DIMENSION = {
  w: 1280,
  h: 720,
};

function toggleFullScreen() {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
  }
}

const DELAY = 60 * 1000; //60s
let timer: any;

function Page() {
  const [type, setType] = React.useState<1 | 2 | 3>(3);
  const [departureTrips, setDepartureTrips] = React.useState<TripStatusReportDto[]>([]);
  const [arrivalTrips, setArrivalTrips] = React.useState<TripStatusReportDto[]>([]);

  const [dimension, setDimension] = React.useState<{ width: number; height: number; ratio: number }>({
    width: Math.ceil((window.innerHeight / 9) * 16),
    height: window.innerHeight,
    ratio: window.innerHeight / ORIGIN_DIMENSION.h,
  });

  const getTripData = (getDeparture: boolean, getReturn: boolean) => {
    if (getDeparture) {
      apiSdk.TripStatusReportService.getReports({ isDeparture: true }).then(res => setDepartureTrips(res));
    }
    if (getReturn) {
      apiSdk.TripStatusReportService.getReports({ isDeparture: false }).then(res => setArrivalTrips(res));
    }
  };

  const intervalUpdate = _type => {
    if (timer) {
      window.clearInterval(timer);
    }
    timer = window.setInterval(() => {
      getTripData(_type !== 2, _type !== 1);
    }, 3 * 60 * 1000);
  };

  React.useEffect(() => {
    getTripData(type !== 2, type !== 1);
    intervalUpdate(type);
  }, [type]);

  React.useEffect(() => {
    const handleResize = () => {
      setDimension({
        width: Math.ceil((window.innerHeight / 9) * 16),
        height: window.innerHeight,
        ratio: window.innerHeight / ORIGIN_DIMENSION.h,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  console.log(dimension);
  return (
    <div
      id="tv-screen"
      style={
        {
          '--scale': dimension.ratio,
        } as any
      }
    >
      <div className="action">
        <div className="inner-content">
          <Radio.Group value={type}>
            <Radio value={1} onClick={() => setType(1)}>
              {t('Only Departure trips')}
            </Radio>
            <Radio value={2} onClick={() => setType(2)}>
              {t('Only Arrival trips')}
            </Radio>
            <Radio value={3} onClick={() => setType(3)}>
              All
            </Radio>
          </Radio.Group>
          <Divider />
          <Button type="primary" onClick={toggleFullScreen}>
            {t('Toggle full screen')}
          </Button>
        </div>
      </div>
      {type === 3 ? (
        <Carousel autoplay autoplaySpeed={DELAY} infinite>
          <TripPageItem title={t('Departure trips')} trips={departureTrips} ratio={dimension.ratio} />

          <TripPageItem title={t('Arrival trips')} trips={arrivalTrips} ratio={dimension.ratio} />
        </Carousel>
      ) : null}
      {type === 1 ? (
        <Carousel>
          <TripPageItem title={t('Departure trips')} trips={departureTrips} ratio={dimension.ratio} />
        </Carousel>
      ) : null}
      {type === 2 ? (
        <Carousel>
          <TripPageItem title={t('Arrival trips')} trips={arrivalTrips} ratio={dimension.ratio} />
        </Carousel>
      ) : null}
    </div>
  );
}

export default function TripStatusTVScreen() {
  return (
    <PageWithPermissions permissions={[APP_PERMISSIONS.ViewTripStatus]}>
      <Page />
    </PageWithPermissions>
  );
}
